<template>
  <div class="riw-rail">
    <div v-if="stats && stats.rows.length" class="riw-rail__stats">
      <div class="riw-rail__stats-title">{{ stats.title }}</div>
      <div v-for="row in stats.rows" :key="row.label" class="riw-rail__stat">
        <span>{{ row.label }}</span>
        <span class="riw-num" :class="row.tone ? `is-${row.tone}` : ''" :title="String(row.value)">{{ row.value }}</span>
      </div>
    </div>
    <div v-if="infoRows.length" class="riw-rail__info">
      <div v-for="row in infoRows" :key="row.text" class="riw-rail__info-row" :title="row.title || row.text">
        <v-icon size="16">{{ row.icon }}</v-icon>
        <span>{{ row.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/** Rail summary box + info rows for the Register Import wizard (WizardShell #sidebar-extras). */
export default {
  name: 'ImportRailSummary',
  props: {
    /** { title, rows: [{ label, value, tone: 'hl'|'wn'|'muted'|'' }] } or null */
    stats: { type: Object, default: null },
    /** [{ icon, text, title }] */
    infoRows: { type: Array, default: () => [] },
  },
};
</script>
